import { LocalStorage } from "./localStorage";

class IsShowPostSentModerationDialogStorage extends LocalStorage {
	public constructor() {
		super({
			storageKey: "is_show_post_sent_moderation_dialog",
		});
	}
}

export const isShowPostSentModerationDialogStorage = new IsShowPostSentModerationDialogStorage();
